import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledBoxProps {
  layoutHeight: number;
}
const StyledBox = styled(Box)<StyledBoxProps>(({ theme, layoutHeight }) => ({
  height: `calc(80vh - ${layoutHeight}px )`,
   [theme.breakpoints.down('lg')]: {
      height: '100vh',
    },
  position: 'relative',
  '& .HSBGContainer': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },
  '& .HSVideo': {
    width: '100%',
    objectFit: 'cover',
    height: '100%',
    [theme.breakpoints.down('lg')]: {
      height: '100%',
    },
    '&.showMobileAndTabletAndDesktop': {
      [theme.breakpoints.up('xl')]: {
        display: 'none !important',
      },
    },
    '&.showLargeDESKTOP':{
      [theme.breakpoints.down('xl')]: {
        display: 'none !important',
      },
    },
  },
  '& .HSBGGradient': {
    background:
      `linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0) 20%,rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 0.5) 80%,${theme.palette.background.primary} 100%);`,
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
  },

  '& .HSContentContainer': {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'center',
    textAlign: 'center',
    margin: 'auto',
    maxWidth: theme.typography.pxToRem(1000),
    height: '100%',
    paddingBottom: theme.spacing(10),
    zIndex: 5,
    [theme.breakpoints.down('xl')]: {
      maxWidth: theme.typography.pxToRem(850),
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
  },
  '& .HSBGPattern': {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: theme.typography.pxToRem(150),
    zIndex: 2,
    // Smooth fade at the top, normal at the bottom
    maskImage: `linear-gradient(
        to bottom,
         ${alpha(theme.palette.common.black, 0)} 0%,
         ${alpha(theme.palette.common.black, 0.7)} 90%
      )`,
  },
}));

export default StyledBox;
